const newConversation = async (
    conversationID, 
    title, 
    message,
    length,
    client,
    timestamp,
    uuid,
    authID,
    authForName,
    db
) => {

        await db.collection('Conversations').doc().set({
            ID: conversationID,
            Compagny: client,
            CompagnyID: client,
            Position: length,
            Timestamp: timestamp,
            Title: title,
            Deleted: false,
        });

        await db.collection('Messages').doc().set({
            ID: uuid,
            Compagny: client,
            CompagnyID: client,
            Position: 1,
            Timestamp: timestamp,
            Message: message,
            ConversationID: conversationID,
            UserID: authID || "",
            UserName: authForName || "",
            Type: 'decca',
            Deleted: false,
        });
}

export default newConversation;